import React from 'react';
import { useAppContext } from '../../../../../AppContext';
import styled, { css } from 'styled-components';
import styles from './Body.module.scss';
//@ts-ignore
import classNames from 'classnames';
import { StyleService } from '../../../../services';
import { DictionaryType } from '../../../../types/DictionaryType';

enum BodyVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}

type PropsType = {
  id?: string;
  children: React.ReactNode;
  variant?: BodyVariant;
  classNames?: string;
};

const Body = (props: PropsType) => {
  const context = useAppContext();
  const whitelabelingStyles = StyleService.apply(
    'module:container:body',
    context.styles
  );

  const classes = classNames(
    styles.body,
    props.variant ? styles[props.variant] : styles.primary,
    props.classNames && props.classNames
  );
  return (
    <BodyDiv className={classes} styles={whitelabelingStyles}>
      {props.children}
    </BodyDiv>
  );
};

const BodyDiv = styled.section<{ styles: DictionaryType<string> }>`
  ${(props) => css`
    --module-body-background-color: ${props.styles.backgroundColor};
  `}
`;


Body.BodyVariant = BodyVariant;
export default Body;
